import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader';
import { userAppContext } from '../Context/Context';
import Enrichment from '../modules/enrichment/Enrichment';
import { UserContext } from '../types';

export default function EnrichmentPage() {
  const { isAuthenticated } = userAppContext() as unknown as UserContext;

  return (
    <>
      <Helmet>
        <title>DISGENET: Enrichment Analysis</title>
        <meta name="description" content="Perform enrichment analysis with DISGENET." />
      </Helmet>
      <CommonHeader />
      <div className="p-4 advanced-research container-view">
              <div className="search-results-container">
                {isAuthenticated ? (
                  <Enrichment />
                ) : (
                  <div className="auth-message text-center">
                    <h6>This feature is available only for authenticated users</h6>
                    <h6>
                      See all the <a href="/plans" style={{color: "#D02591"}}>plans here</a>.
                    </h6>
                    <img
                      src="../../../static/images/enrichment.png"
                      alt="Not authenticated illustration"
                      className="mt-4"
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        margin: '0 auto',
                        opacity: 0.5,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
    </>
  );
}
